import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavParams, Slides, ViewController} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Photo} from "../../models/data.model";
@IonicPage()
@Component({
  selector: 'page-photos-viewer',
  templateUrl: 'photos-viewer.html',
})
export class PhotosViewerPage {

  @ViewChild(Slides) slides: Slides;
  photos: Photo[] = [];

  constructor(public navParams: NavParams,
              public viewCtrl: ViewController,
              public data: DataProvider) {
    this.photos = navParams.get('photos');
  }

  protected closeModal(): void {
    this.viewCtrl.dismiss().catch();
  }

  protected static slideDrag(event: any) {
    let slider = event.path[event.eventPhase].getBoundingClientRect();
    let image = event.target.getBoundingClientRect();
    if (image.left == 0  || image.right == slider.width || image.width <= slider.width) return;
    event.preventDefault();
    event.stopPropagation();
  }

  protected showSlide(i) {
    this.slides.slideTo(i, 200);
  }

  protected isThisPhotoSelected(index: number): boolean {
    return (this.slides) ? this.slides.getActiveIndex() === index : false;
  }

  protected getSlidesPerView() {
    if (this.photos.length > 5) return 5;
    return this.photos.length;
  }

  protected previousPhoto() {
    this.slides.slidePrev();
  }

  protected nextPhoto() {
    this.slides.slideNext();
  }
}



// WEBPACK FOOTER //
// ./src/pages/photos-viewer/photos-viewer.ts